import React from 'react';

const NotFound = () => <div>Ope... Guess there's nothing found here...</div>

export default NotFound;